import { Link } from "react-router-dom";
import {
  Users2, Bot, Briefcase, Gavel, BarChart3, ShieldAlert,
  Wallet, Landmark, DollarSign, Megaphone, Play, ListTodo, CreditCard,
  Package, Activity, Settings, LayoutDashboard,
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const SECTIONS = [
  {
    label: "Marketplace",
    color: "text-blue-400",
    items: [
      { title: "Users",       url: "/admin/users",     icon: Users2 },
      { title: "Agents",      url: "/admin/agents",    icon: Bot },
      { title: "Jobs",        url: "/admin/jobs",      icon: Briefcase },
      { title: "Recent Bids", url: "/admin/bids",      icon: Gavel },
      { title: "Analytics",   url: "/admin/analytics", icon: BarChart3 },
      { title: "Disputes",    url: "/admin/disputes",  icon: ShieldAlert },
    ],
  },
  {
    label: "Finance & Ops",
    color: "text-emerald-400",
    items: [
      { title: "Payments",     url: "/admin/payments",     icon: CreditCard },
      { title: "Treasury",     url: "/admin/treasury",     icon: Wallet },
      { title: "Blockchain",   url: "/admin/blockchain",   icon: Landmark },
      { title: "Cert Revenue", url: "/admin/cert-revenue", icon: DollarSign },
    ],
  },
  {
    label: "Growth",
    color: "text-amber-400",
    items: [
      { title: "Promotions",  url: "/admin/promotions", icon: Megaphone },
      { title: "Launch OS",   url: "/admin/launch",     icon: Play },
      { title: "Week 1 GTM",  url: "/admin/gtm",        icon: ListTodo },
    ],
  },
  {
    label: "Content",
    color: "text-purple-400",
    items: [
      { title: "Quiz Packs",  url: "/admin/quiz-packs",  icon: Package },
      { title: "Quiz Timing", url: "/admin/quiz-timing", icon: Activity },
      { title: "Templates",   url: "/admin/templates",   icon: Settings },
    ],
  },
  {
    label: "AI Agents",
    color: "text-cyan-400",
    items: [
      { title: "OpenClaw", url: "/admin/openclaw", icon: Bot },
    ],
  },
] as const;

export default function AdminDashboard() {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h2 className="text-sm font-mono text-primary uppercase tracking-[0.2em] mb-1">Admin</h2>
        <h1 className="text-3xl font-display font-bold">Dashboard</h1>
        <p className="text-muted-foreground text-sm mt-1">
          All admin sections in one place.
        </p>
      </div>

      {/* Section grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {SECTIONS.map((section) => (
          <Card key={section.label} className="glass-panel">
            <CardHeader className="pb-3">
              <CardTitle className={`text-sm font-mono uppercase tracking-wider ${section.color}`}>
                {section.label}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-1">
                {section.items.map((item) => (
                  <li key={item.url}>
                    <Link
                      to={item.url}
                      className="flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-surface-subtle transition-colors"
                    >
                      <item.icon className="h-4 w-4 shrink-0" />
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
